import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Dev overlay can still surface this after other listeners; match loosely and use capture phase.
function isResizeObserverLoopError(event: ErrorEvent): boolean {
  const msg = typeof event.message === 'string' ? event.message : '';
  const nested =
    event.error &&
    typeof event.error === 'object' &&
    event.error !== null &&
    'message' in event.error &&
    typeof (event.error as { message?: unknown }).message === 'string'
      ? String((event.error as { message: string }).message)
      : '';
  return /ResizeObserver loop/i.test(msg) || /ResizeObserver loop/i.test(nested);
}

window.addEventListener(
  'error',
  (event: Event) => {
    if (!isResizeObserverLoopError(event as ErrorEvent)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true,
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/offline-sw.js`).catch(() => {
      /* optional — offline POS still works via IndexedDB when tab is open */
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();